import { ClaudeIcon } from '@/assets/icons/claude';
import { DeepSeekIcon } from '@/assets/icons/deepseek';
import { GeminiIcon } from '@/assets/icons/gemini';
import { GrokIcon } from '@/assets/icons/grok';
import { KimiIcon } from '@/assets/icons/kimi';
import { MetaIcon } from '@/assets/icons/meta';
import { OpenAiIcon } from '@/assets/icons/openai';
import { ZaiIcon } from '@/assets/icons/zai';
import { cn } from '@/lib/utils';

import type { ModelCompany } from './agent-picker.query';

const LOGOS = {
  anthropic: ClaudeIcon,
  openai: OpenAiIcon,
  google: GeminiIcon,
  zai: ZaiIcon,
  moonshot: KimiIcon,
  deepseek: DeepSeekIcon,
  xai: GrokIcon,
  meta: MetaIcon,
} as const satisfies Record<ModelCompany, typeof ClaudeIcon>;

export const ModelLogo = ({
  company,
  className,
}: {
  company: ModelCompany | null;
  className?: string;
}) => {
  if (!company)
    return (
      <span
        aria-hidden
        className={cn('rounded-full border-[1.5px] border-current', className)}
      />
    );
  const Logo = LOGOS[company];
  return <Logo className={className} />;
};
